const api = {
  GET_LIST_MASTER_BCKO: '/index.php?r=api/v1/bcko_branch/bcko-branch',
  CREATE_MASTER_BCKO: '/index.php?r=api/v1/bcko_branch/bcko-branch/create',
  UPDATE_MASTER_BCKO: '/index.php?r=api/v1/bcko_branch/bcko-branch/edit',
};

export default api;
